import React, { useState } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { useLocation, useNavigate } from 'react-router-dom';
import { edit_icon, eye_icon, user } from '../../../assets/imgs';
import StatusComp from '../../../components/StatusComp';


const CompanyAddAdmin = () => {

    const navigate = useNavigate()
    const location = useLocation()

    const [formData, setFormData] = useState({
        userName: "",
        email: "",
        mobile: "",
        role: "",
        adminId: "",
        password: "",
        confirmPassword: ""
    });

    const [errors, setErrors] = useState({});

    const [visible, setVisible] = useState(false);
    const [confVisible, setConfVisible] = useState(false);
    const [logo, setLogo] = useState()

    const type = location?.state?.type;


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        setErrors((prev) => ({
            ...prev,
            [name]: ''
        }))
    };

    const validate = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const singaporeMobileRegex = /^[89]\d{7}$/;

        if (!formData.userName.trim()) newErrors.userName = "User Name is required";
        if (!formData.email.trim() || !emailRegex.test(formData.email))
            newErrors.email = "Valid Email is required";
        if (!formData.mobile.trim() || !singaporeMobileRegex.test(formData.mobile)) {
            newErrors.mobile = "Enter valid 8-digit Singapore number";
        }
        if (!formData.role) newErrors.role = "Select a role";
        // if (!formData.adminId.trim()) newErrors.adminId = "Admin ID is required";
        if (!formData.password || formData.password.length < 6)
            newErrors.password = "Password must be at least 6 characters";
        if (formData.confirmPassword !== formData.password)
            newErrors.confirmPassword = "Passwords do not match";
        if (!logo) newErrors.logo = "Company Logo is required"

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validate()) {
            console.log("Submit successful", formData);
            navigate('/admin'); // or API call here
        }
    };

    const handleLogoChange = (event) => {
        const image = event.target.files[0];
        if (image) {
            setLogo(image);
            setErrors((prev) => ({
                ...prev,
                logo: "",
            }));
        }


    };




    return (
        <div className='dashRightView'>

            <StatusComp
                name={'Admin'}
                type={type}
            />

            <div className='d-flex flex-wrap gap-5'>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>User Name</p>
                    <input className='input-box' name="userName"
                        value={formData.userName}
                        onChange={handleChange} type="text" placeholder='User Name' />
                    {errors.userName && <p className="err">{errors.userName}</p>}
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>Email</p>
                    <input className='input-box' name="email"
                        value={formData.email}
                        onChange={handleChange} type="email" placeholder='Email' />
                    {errors.email && <p className="err">{errors.email}</p>}
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>Singapore Mobile Number</p>
                    <input className='input-box' name="mobile"
                        value={formData.mobile}
                        onChange={handleChange} type="number" placeholder='+65 Mobile number' />
                    {errors.mobile && <p className="err">{errors.mobile}</p>}
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>Roles</p>
                    <select name="role"
                        value={formData.role}
                        onChange={handleChange} className='input-box'>
                        <option>Super Admin</option>
                        <option>Admin</option>
                        <option>Manager</option>
                    </select>
                    {errors.role && <p className="err">{errors.role}</p>}
                </div>
                {/* <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 primary'>Admin ID</p>
                    <input name="adminId"
                        value={formData.adminId}
                        onChange={handleChange} className='input-box' type="text" placeholder='Admin ID' />
                    {errors.adminId && <p className="err">{errors.adminId}</p>}
                </div> */}
                {type == 'add' && (<div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>Admin Profile Image(size 2 MB)</p>
                    <input className='input-box' name="logo"
                        onChange={handleLogoChange} type="file" placeholder='Admin Profile Image' accept='image/*' />
                    {errors.logo && <p className="err">{errors.logo}</p>}
                </div>)}

                {type !== 'add' && (
                    <div className='col-md-5'>
                        <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>
                            Admin Profile Image
                        </p>


                        <img
                            src={logo ? URL.createObjectURL(logo) : user}
                            alt=""
                            className="user"
                        />

                        {type !== 'view' && (
                            <>

                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    id="edit-logo"
                                    onChange={handleLogoChange}
                                />


                                <button
                                    onClick={() => document.getElementById('edit-logo').click()}
                                    className="cust-btn"
                                >
                                    <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                                </button>
                            </>
                        )}
                    </div>
                )}


                {type !== 'view' && (<div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>Password</p>
                    <div className='input-box ac-jb ' >
                        <LockOutlinedIcon className='emial-icon' />
                        <input name="password"
                            value={formData.password}
                            onChange={handleChange} type={visible ? "text" : "password"} maxLength={20} placeholder='Password' />
                        {!visible && (
                            <img
                                src={eye_icon}
                                onClick={() => setVisible(!visible)}
                                className="eye-icon pointer mb-1"
                                alt=""
                            />
                        )}
                        {visible && (
                            <VisibilityIcon onClick={() => setVisible(!visible)} className="eye-icon " />
                        )}
                    </div>
                    {errors.password && <p className="err">{errors.password}</p>}
                </div>)}
                {type !== 'view' && (<div className='col-md-5'>
                    <p className='f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary'>Confirm Password</p>
                    <div className='input-box ac-jb' >
                        <LockOutlinedIcon className='emial-icon' />
                        <input name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange} type={confVisible ? "text" : "password"} maxLength={20} placeholder='Confirm Password' />
                        {!confVisible && (
                            <img
                                src={eye_icon}
                                onClick={() => setConfVisible(!confVisible)}
                                className="eye-icon pointer mb-1"
                                alt=""
                            />
                        )}
                        {confVisible && (
                            <VisibilityIcon onClick={() => setConfVisible(!confVisible)} className="eye-icon " />
                        )}
                    </div>
                    {errors.confirmPassword && <p className="err">{errors.confirmPassword}</p>}
                </div>)}
            </div>
            <div className="d-flex ac-jb mt-5">
                <button onClick={() => navigate('/admin')} className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                    Back
                </button>

                {type != "view" && (
                    <button onClick={handleSubmit} className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                        {type == "edit" ? "Submit" : "Add"}
                    </button>
                )}

            </div>
        </div>
    )
}

export default CompanyAddAdmin